import { AsyncPipe, CommonModule } from '@angular/common'
import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { Router, RouterModule } from '@angular/router'
import {
    LanguageDropdownComponent,
    SpanishDirective,
} from '@baboor/baboor-language'
import { ProfileStateService } from '@baboor/baboor-user'
import { UserLoginStatusComponent } from '@baboor/common-components'
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco'
import { ButtonModule } from '@openng/optimus-ui/button'
import { publicHeaderData } from '../../header-routes.data'
import { HeaderAuthService } from '../services/header-auth.service'
import { HeaderService } from '../services/header.service'

@Component({
    selector: 'app-header-public',
    imports: [
        RouterModule,
        AsyncPipe,
        CommonModule,
        UserLoginStatusComponent,
        LanguageDropdownComponent,
        TranslocoModule,
        SpanishDirective,
        ButtonModule,
    ],
    templateUrl: './header-public.component.html',
    styleUrl: './header-public.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [provideTranslocoScope('header')],
})
export class HeaderPublicComponent {
    readonly headerAuthService = inject(HeaderAuthService)
    readonly headerService = inject(HeaderService)
    readonly profileStateService = inject(ProfileStateService)
    private router = inject(Router)

    headerRoutesData = publicHeaderData

    leftLinks = publicHeaderData.filter(
        (item) => item.position === 'left' && !item.hidden,
    )

    rightLinks = publicHeaderData.filter(
        (item) => item.position === 'right' && !item.hidden,
    )

    navigateToHome(): void {
        this.router.navigate(['/']).then(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        })
    }
}
